module.exports = __webpack_public_path__ + "img/constec_white.5caf0a61.svg";